function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function removeParenthesizedInfo(string) {
    return string.replace(/\s?\(.*\)$/g, '').trim();
}

function pluralize(num, single, plural) {
    return num === 1 ? single : plural;
}

export function convertAmps(string) {
    return string.replace('&amp;', '&');
}

export function packageOrTickets() {
    return !NOJESRESOR_PRODUCT.hotels.optional &&
    !NOJESRESOR_PRODUCT.hotels.without
        ? 'Hotellpaket'
        : 'Biljetter';
}

export { capitalizeFirstLetter, removeParenthesizedInfo, pluralize };
